<div class="star-icon" (click)="fav(element, true)" *ngIf="!element?.isFavourite">
    <mat-icon>star_border</mat-icon>
</div>
<div class="star-icon" (click)="fav(element, false)" *ngIf="element?.isFavourite">
    <mat-icon class="star-active">star</mat-icon>
</div>